<template>
  <ul class="menu">
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/chart')"
        class="menu__item">
        Track progress
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/preferences')"
        class="menu__item">
        My Goals
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/playlists')"
        class="menu__item">
        My Playlists
      </a>
    </li>
    <li v-if="!isPortalTypeBooks">
      <a
        :href="$getSubdomainLink('portal', '/video/favorite')"
        class="menu__item">
        My Favorites
      </a>
    </li>
    <li v-else>
      <a
        :href="$getSubdomainLink('portal', '/books/favorite')"
        class="menu__item">
        My Favorites
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/my-profile/personal-info')"
        class="menu__item">
        My Profile
      </a>
    </li>
    <li>
      <button
        @click="logout"
        class="btn btn-menu-link">
        Log out
      </button>
    </li>
  </ul>
</template>
<script>
  import { useAuthStore, useEnabledStore } from "@/stores";
  export default {
    data() {
      return {
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.portalTypeBooks;
      },
    },
    created() {
      this.checkPortalType();
    },
    methods: {
      logout() {
        this.authStore.logout();
      },
      async checkPortalType() {
        this.enabledStore.checkPortalType();
      },
    },
  };
</script>
